export const addOrgAdmin = [{
    key: 'email',
    type: 'email',
    value: '',
    valid: false,
    elementConfig: {
        name: 'email',
        label: 'Email Id',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

},

]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/ManageOrgAdmins/formData.js